import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "lz-container" }
const _hoisted_2 = { class: "news-wrapper lz-mt-16" }
const _hoisted_3 = {
  key: 0,
  class: "filterList newsList"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 2,
  class: "lz-mt-16 lz-flex lz-justify-center"
}

import { ref, onMounted, onBeforeUnmount, provide } from 'vue';
  import LzNewsItem from './LzNewsItem.vue';
  import LzNewsFilter from './LzNewsFilter.vue';
  import LzSpinner from '../base/LzSpinner.vue';
  import { checkIsMobile, newsRestEndpoint } from '@/utils';

  const limit = 30;
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LzNewsList',
  props: {
    lang: {},
    labelDone: {},
    labelClear: {},
    labelClearAll: {},
    labelCategory: {},
    labelYear: {},
    labelFilter: {},
    filterTitle: {},
    noResultsLabel: {}
  },
  setup(__props: any) {

const props = __props;

  

  const newsItems = ref([]);
  const offset = ref(0);
  const isLoading = ref(false);
  const isScrolling = ref(false);
  const hasMoreItems = ref(true);
  const selectedCategories = ref<string[]>([]);
  const selectedYears = ref<string[]>([]);
  const isMobile = ref(checkIsMobile());

  provide('lang', props.lang);
  provide('isMobile', isMobile);
  provide('translations', {
    general: {
      doneLabel: props.labelDone,
      clearLabel: props.labelClear,
      clearAllLabel: props.labelClearAll
    },
    filters: {
      categoryLabel: props.labelCategory,
      yearLabel: props.labelYear,
      filterLabel: props.labelFilter,
      filterTitle: props.filterTitle
    }
  });

  async function fetchNewsItems(categories?: string[], years?: string[], reset = false) {
    if (isLoading.value || !hasMoreItems.value) return;

    isLoading.value = true;
    const url = buildUrl(categories, years);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const items = await response.json() || [];
      updateNewsItems(items, reset);

    } catch (error) {
      console.error('Error fetching news items:', error);
    } finally {
      isLoading.value = false;
    }
  }

  function buildUrl(categories?: string[], years?: string[]): string {
    const baseUrl = `${newsRestEndpoint()}/items/${props.lang}`;
    const params = new URLSearchParams({
      limit: limit.toString(),
      offset: offset.value.toString(),
    });

    categories?.forEach(category => params.append('category', category));
    years?.forEach(year => params.append('year', year));

    return `${baseUrl}?${params.toString()}`;
  }

  function updateNewsItems(items, reset) {
    if (reset) {
      newsItems.value = items;
      offset.value = limit;
    } else {
      newsItems.value.push(...items);
      offset.value += limit;
    }
    hasMoreItems.value = items.length === limit;
  }

  const debouncedHandleFilter = debounce((filters) => {
    selectedCategories.value = filters.categories;
    selectedYears.value = filters.years;
    resetPagination();
    fetchNewsItems(selectedCategories.value, selectedYears.value, true);
  }, 500);

  function resetPagination() {
    offset.value = 0;
    hasMoreItems.value = true;
  }

  function debounce(fn, delay: number) {
    let timeoutID: number | undefined;
    return (...args: unknown[]) => {
      clearTimeout(timeoutID);
      timeoutID = setTimeout(() => fn(...args), delay);
    };
  }

  function handleScroll() {
    const { scrollTop, scrollHeight } = document.documentElement;
    const bottomOfWindow = scrollTop + window.innerHeight >= scrollHeight - 50;
    isScrolling.value = true;
    if (bottomOfWindow) {
      fetchNewsItems(selectedCategories.value, selectedYears.value);
    }
  }

  function resetScroll() {
    isScrolling.value = false;
  }

  function windowResized() {
    isMobile.value = checkIsMobile();
  }

  onMounted(() => {
    fetchNewsItems();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('scrollend', resetScroll);
    window.addEventListener('resize', windowResized);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('scroll', handleScroll);
    window.removeEventListener('scrollend', resetScroll);
    window.removeEventListener('resize', windowResized);
  });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LzNewsFilter, {
      lang: _ctx.lang,
      onFilterApplied: _unref(debouncedHandleFilter)
    }, null, 8, ["lang", "onFilterApplied"]),
    _createElementVNode("div", _hoisted_2, [
      (newsItems.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsItems.value, (newsItem) => {
              return (_openBlock(), _createBlock(LzNewsItem, _mergeProps({
                key: newsItem.id
              }, newsItem), null, 16))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.noResultsLabel), 1)),
      (isLoading.value && isScrolling.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(LzSpinner)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})